import { Asterisk } from "lucide-react";

const ITEMS = [
  "Subwoofery",
  "Wzmacniacze",
  "Skrzynie basowe",
  "Wygłuszanie",
  "Strojenie DSP",
  "Zabudowy custom",
];

const Group = () => (
  <div className="marquee-group flex shrink-0 items-center" aria-hidden="true">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="marquee-text px-2">{item}</span>
        <Asterisk className="h-8 w-8 shrink-0 text-brand" strokeWidth={1.5} />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      className="overflow-hidden border-y border-white/8 py-7 md:py-9"
      data-testid="marquee"
      aria-label="Zakres usług"
    >
      <div className="marquee-track flex w-max">
        <Group />
        <Group />
      </div>
    </section>
  );
}
